<template>
  <div class="register">
    <!-- 登录标题 -->
    <div class="loginTitle">
      <div class="w">
        <div class="loginTitle-logo fl">
          <img src="https://www.myfund.com/images/zhx_logo.png" alt="" class="logo">
        </div>
        <div class="loginTitle-phone fr">
          <p>咨询热线：<span>400-818-8000</span> </p>
        </div>
      </div>
    </div>
    <div class="register_con w common-box">
      <el-row class="row-one">
        <span class="row-one-title">完善交易信息 </span>
      </el-row>
      <ul class="openAccount cleanfix">
        <li class="active">
          <i class="openAccount-icon">1</i>
          上传身份证
        </li>
        <li :class="{active:stepShow == '2'||stepShow == '3'||stepShow == '4'}">
          <i class="openAccount-icon">2</i>
          添加银行卡
        </li>
        <li :class="{active:stepShow == '3'||stepShow == '4'}">
          <i class="openAccount-icon">3</i>
          完善个人信息
        </li>
        <li :class="{active:stepShow == '4'}">
          <i class="openAccount-icon">4</i>
          可交易
        </li>
      </ul>
      <identityCard v-if="stepShow == '1'" @idCard="nextStep"></identityCard>
      <addBank v-if="stepShow == '2'" @addbank="nextStep"></addBank>
      <fillInfo v-if="stepShow == '3'" @saveInfo="nextStep"></fillInfo>
      <finished v-if="stepShow == '4'"></finished>
    </div>
    <lvFooter></lvFooter>
  </div>

</template>

<script>
import lvFooter from '../../components/lv-footer/lv-footer.vue';
import identityCard from "./identityCard";
import addBank from "./addBank";
import fillInfo from "./fillInfo";
import finished from "./finished";

export default {
  name: "openAccpunt",
  components: {
    lvFooter,
    identityCard,
    addBank,
    fillInfo,
    finished

  },
  data () {
    return {
      stepShow: '1'
    }
  },
  methods: {
    nextStep (val) {
      this.stepShow = val
    },
  }
}
</script>

<style lang="less" scoped>
.el-tabs {
  margin: 100px auto;
}
.openAccount {
  margin: 100px auto;
  margin-bottom: 50px;
  padding: 0 30px;
  width: 850px;
  height: 68px;
  color: @colorC3;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid @colorDE;

  li {
    float: left;
    width: 25%;
    height: 68px;
    text-align: center;
    line-height: 68px;
  }
  &-icon {
    display: inline-block;
    width: 23px;
    height: 23px;
    background: @colorC3;
    color: @wColor;
    border-radius: 50%;
    text-align: center;
    line-height: 23px;
  }
  .active {
    color: @color;
    border-bottom: 1px solid @color;
    i {
      background: @color;
    }
  }
}
</style>